import { QUANTITY_FIELD_CONSTANTS } from './quantity-field-constants';
var QuantityFieldFoundation = /** @class */ (function () {
    function QuantityFieldFoundation(_adapter) {
        var _this = this;
        this._adapter = _adapter;
        this._incrementValue = function () { return _this._adapter.increment(); };
        this._decrementValue = function () { return _this._adapter.decrement(); };
        this._incrementButtonSlotChanged = function () { return _this._onIncrementButtonSlotChanged(); };
        this._decrementButtonSlotChanged = function () { return _this._onDecrementButtonSlotChanged(); };
        this._adapter.addIncrementButtonSlotListener(this._incrementButtonSlotChanged);
        this._adapter.addDecrementButtonSlotListener(this._decrementButtonSlotChanged);
    }
    QuantityFieldFoundation.prototype.connect = function () {
        var _this = this;
        this._adapter.addInputDisabledAttributeChangeListener(function () { return _this._syncDisabledStateOfButtons(); });
        this._syncDisabledStateOfButtons();
    };
    QuantityFieldFoundation.prototype.disconnect = function () {
        this._removeIncrementEventListener();
        this._removeDecrementEventListener();
        this._removeIncrementButtonSlotListener();
        this._removeDecrementButtonSlotListener();
        this._adapter.removeInputDisabledAttributeChangeListener();
    };
    QuantityFieldFoundation.prototype._onIncrementButtonSlotChanged = function () {
        this._addIncrementEventListener();
    };
    QuantityFieldFoundation.prototype._onDecrementButtonSlotChanged = function () {
        this._addDecrementEventListener();
    };
    QuantityFieldFoundation.prototype._addIncrementEventListener = function () {
        this._adapter.addIncrementEventListener('click', this._incrementValue);
    };
    QuantityFieldFoundation.prototype._addDecrementEventListener = function () {
        this._adapter.addDecrementEventListener('click', this._decrementValue);
    };
    QuantityFieldFoundation.prototype._removeIncrementEventListener = function () {
        this._adapter.removeIncrementEventListener('click', this._incrementValue);
    };
    QuantityFieldFoundation.prototype._removeDecrementEventListener = function () {
        this._adapter.removeDecrementEventListener('click', this._decrementValue);
    };
    QuantityFieldFoundation.prototype._removeIncrementButtonSlotListener = function () {
        this._adapter.removeIncrementButtonSlotListener(this._incrementButtonSlotChanged);
    };
    QuantityFieldFoundation.prototype._removeDecrementButtonSlotListener = function () {
        this._adapter.removeDecrementButtonSlotListener(this._decrementButtonSlotChanged);
    };
    QuantityFieldFoundation.prototype._syncDisabledStateOfButtons = function () {
        var isDisabled = this._adapter.inputHasAttribute(QUANTITY_FIELD_CONSTANTS.attributes.DISABLED);
        if (isDisabled) {
            this._adapter.addDecrementButtonAttribute(QUANTITY_FIELD_CONSTANTS.attributes.DISABLED);
            this._adapter.addIncrementButtonAttribute(QUANTITY_FIELD_CONSTANTS.attributes.DISABLED);
        }
        else {
            this._adapter.removeIncrementButtonAttribute(QUANTITY_FIELD_CONSTANTS.attributes.DISABLED);
            this._adapter.removeDecrementButtonAttribute(QUANTITY_FIELD_CONSTANTS.attributes.DISABLED);
        }
    };
    Object.defineProperty(QuantityFieldFoundation.prototype, "required", {
        get: function () {
            return this._required;
        },
        set: function (value) {
            if (this._required === value) {
                return;
            }
            this._required = value;
            if (this._required) {
                this._adapter.setHostAttribute(QUANTITY_FIELD_CONSTANTS.attributes.REQUIRED);
                this._adapter.addRootClass(QUANTITY_FIELD_CONSTANTS.classes.REQUIRED);
            }
            else {
                this._adapter.removeHostAttribute(QUANTITY_FIELD_CONSTANTS.attributes.REQUIRED);
                this._adapter.removeRootClass(QUANTITY_FIELD_CONSTANTS.classes.REQUIRED);
            }
            this._adapter.setLabelAsRequired(this._required);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuantityFieldFoundation.prototype, "invalid", {
        get: function () {
            return this._invalid;
        },
        set: function (value) {
            if (this._invalid === value) {
                return;
            }
            this._invalid = value;
            if (this._invalid) {
                this._adapter.setHostAttribute(QUANTITY_FIELD_CONSTANTS.attributes.INVALID);
                this._adapter.addRootClass(QUANTITY_FIELD_CONSTANTS.classes.INVALID);
                this._adapter.addTextFieldAttribute(QUANTITY_FIELD_CONSTANTS.attributes.INVALID);
            }
            else {
                this._adapter.removeHostAttribute(QUANTITY_FIELD_CONSTANTS.attributes.INVALID);
                this._adapter.removeRootClass(QUANTITY_FIELD_CONSTANTS.classes.INVALID);
                this._adapter.removeTextFieldAttribute(QUANTITY_FIELD_CONSTANTS.attributes.INVALID);
            }
        },
        enumerable: true,
        configurable: true
    });
    return QuantityFieldFoundation;
}());
export { QuantityFieldFoundation };
